<template>
  <footer class="page-footer">
    <div class="info">
      <div>
        {{ $t('app.pageFooter.forHelp') }}
        <a :href="'mailto:' + $t('app.pageFooter.supportEmail')">{{
          $t('app.pageFooter.supportEmail')
        }}</a>
      </div>
      <font-awesome-icon class="bullet-icon" icon="circle" />
      <div>
        {{ $t('app.pageFooter.copyright') }} &copy;
        <a :href="$t('app.pageFooter.copyrightAddress')" target="_blank">{{
          $t('app.pageFooter.copyrightName')
        }}</a>
        {{ $t('app.pageFooter.copyrightYears') }}
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter'
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../styles/variables';

.page-footer {
  text-align: center;
  margin: 24px auto;
  width: $main-content-width;

  .info {
    background: $background-level-2;
    color: $text-color-light;
    padding: 50px 0;
    font-size: 18px;
    letter-spacing: -0.18px;
    line-height: 21px;
    div {
      display: inline-block;
      a {
        text-decoration: none;
        color: black;
        font-weight: bold;
      }

      a:link,
      a:visited {
        color: black;
        font-weight: bold;
      }
    }
  }
  &.login-footer {
    width: $login-page-width;

    .info {
      font-size: 0.9rem;
      background: none;
      .bullet-icon {
        display: none;
      }
      div {
        a {
          text-decoration: none;
          color: $white;
          font-weight: bold;
        }
      }
    }
  }

  .bullet-icon {
    font-size: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media print {
  .page-footer {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  * {
    font-size: 0.8rem;
  }
}
</style>
